import React from "react";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, {tableCellClasses} from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {styled} from "@mui/material/styles";
import Api, {APIs} from "../../../../Api";
import {makeHeading} from "../../../digitalarz/data-grid/components/utils";

const StyledTableCell = styled(TableCell)(({theme}) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({theme}) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));


const SROSector = () => {
    const [sroSector, setSROSector] = React.useState([])
    React.useEffect(() => {
        Api.get(APIs.MoPD_SRO_SECTOR).then((payload) => {
            if (payload) {
                setSROSector(payload)
            }
        });
    }, [])
    return (
        <React.Fragment>
            <Table sx={{minWidth: 700}} aria-label="customized table">
                <TableHead>
                    <TableRow>
                        {sroSector.length > 0 && Object.keys(sroSector[0]).map((key) => <StyledTableCell
                            key={"head-" + key}>{makeHeading(key)}</StyledTableCell>)}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {sroSector.map((row, index) => (
                        <StyledTableRow key={"row-" + index}>
                            {sroSector.length > 0 && Object.keys(sroSector[0]).map((key) => <StyledTableCell
                                key={`row-${index}-${key}`}>{row[key]}</StyledTableCell>)}

                        </StyledTableRow>
                    ))}
                </TableBody>
            </Table>
        </React.Fragment>
    )
}

export default SROSector
